import { FunctionComponent } from 'react';
import { useSelector } from 'react-redux';
import { useConfig } from '@browsing/config';
import { useConsentManager } from '@browsing/tracking';

import { toNumberOrZero } from '@client/helpers';
import { getCustomer } from '@client/redux/modules/customer';
import { addUsabillaToWindow } from './script';

export const Usabilla: FunctionComponent = () => {
    const config = useConfig();
    const [hasConsent] = useConsentManager('usabilla_lounge');
    const customer = useSelector(getCustomer);

    const visits = toNumberOrZero(window.localStorage.getItem('zl_mylounge_page_view_count'));
    if (config?.isEnabled('usabilla') && hasConsent) {
        addUsabillaToWindow({
            campaignId: (config.usabilla as { campaignId?: string }).campaignId,
            auxiliaryData: {
                customer: customer?.hashedCustomerNumber,
                myLoungePageViewCount: visits,
            },
        });
    }

    return null;
};

export default Usabilla;
